<template>
    <div>
        <div class="back">
            <a href="/function"><img src="/static/tutorial/back.png" alt=""></a>
        </div>
        <div class="introduction">

            <h1>{{this.EventBus.getText("file_title")}}</h1>
            <p>{{this.EventBus.getText("file_title_ex")}}</p>
            <img :src=file_img alt="">
        </div>
        <div class="container_wrap">
            <div class="container">
            <div class="item1_wrap">
                <div class="item item1">
                    <img src="/static/tutorial/functions/file/1. 파일/1. 새로 만들기.png" alt="">
                    <h2>{{this.EventBus.getText("file_new")}}</h2>
                    <p>{{this.EventBus.getText("file_new_ex")}}</p>
                </div>
            </div>
            
            <div class="item item2" v-for="data in file1" v-bind:key="data.index">
                <div v-if="data.index <=file1.length">
                    <img :src=data.img  alt="">
                    <h2>{{data.subject}}</h2>
                    <p>{{data.explain}}</p>
                </div>
            </div>
            <div class="item1_wrap">
                <div class="item item1">
                    <img src="/static/tutorial/functions/file/1. 파일/8. 가져오기.png" alt="">
                    <h2>{{this.EventBus.getText("file_import")}}</h2>
                    <p>{{this.EventBus.getText("file_import ex")}}</p>
                </div>
            </div>
            <div class="item item2" v-for="data in file2" v-bind:key="data.index">
                <div v-if="data.index >8">
                    <img :src=data.img  alt="">
                    <h2>{{data.subject}}</h2>
                    <p>{{data.explain}}</p>
                </div>
            </div>
            <div class="item1_wrap">
                <div class="item item1">
                    <img src="/static/tutorial/functions/file/1. 파일/11. STL 번개 뷰어.png" alt="">
                    <h2>{{this.EventBus.getText("file_STLviewer")}}</h2>
                    <p>{{this.EventBus.getText("file_STLviewer_ex")}}</p>
                </div>
            </div>
            
            <div class="item item2">
                <img src="/static/tutorial/functions/file/1. 파일/12. 종료.png" alt="">
                <h2>{{this.EventBus.getText("file_exit")}}</h2>
                <p>{{this.EventBus.getText("file_exit_ex")}}</p>
            </div>
        </div>
        </div>

        <js/>

    </div>
</template>
<script>
import File from '../../assets/language/file.json'
export default {
    beforeCreate() {
        this.EventBus.loadLanguage(File);
    },
    data(){
        return{
            file_img : this.EventBus.getText("file_img"),
            file1: [
                {
                    index: 1,
                    img : '/static/tutorial/functions/file/1. 파일/2. 열기.png',
                    subject: this.EventBus.getText("file_open"),
                    explain: this.EventBus.getText("file_open_ex"),
                },
                {
                    index: 2,
                    img :  '/static/tutorial/functions/file/1. 파일/3. 파일 추가하기.png',
                    subject: this.EventBus.getText("file_add"),
                    explain: this.EventBus.getText("file_add_ex"),
                },
                {
                    index: 3,
                    img :  '/static/tutorial/functions/file/1. 파일/4. 최근 파일 열기.png',
                    subject: this.EventBus.getText("file_recent"),
                    explain: this.EventBus.getText("file_recent_ex"),
                },
                {
                    index: 4,
                    img :  '/static/tutorial/functions/file/1. 파일/5. 저장.png',
                    subject: this.EventBus.getText("file_save"),
                    explain: this.EventBus.getText("file_save_ex")
                },
                {
                    index: 5,
                    img :  '/static/tutorial/functions/file/1. 파일/5. PC로 저장.png',
                    subject: this.EventBus.getText("file_savePC"),
                    explain: this.EventBus.getText("file_savePC_ex")
                },
                {
                    index: 6,
                    img :  '/static/tutorial/functions/file/1. 파일/5. 이메일로 보내기.png',
                    subject: this.EventBus.getText("file_email"),
                    explain: this.EventBus.getText("file_email_ex")
                },
                {
                    index: 7,
                    img :  '/static/tutorial/functions/file/1. 파일/6. 선택한 것만 저장.png',
                    subject: this.EventBus.getText("file_saveSelected"),
                    explain: this.EventBus.getText("file_saveSelected_ex")
                },
                {
                    index: 8,
                    img :  '/static/tutorial/functions/file/1. 파일/6. PC로 저장.png',
                    subject: this.EventBus.getText("file_savePCselected"),
                    explain: this.EventBus.getText("file_savePCselected_ex")
                },
                {
                    index: 9,
                    img :  '/static/tutorial/functions/file/1. 파일/6. 이메일로 보내기.png',
                    subject: this.EventBus.getText("file_emailSelected"),
                    explain: this.EventBus.getText("file_emailSelected_ex")
                },
                {
                    index: 10,
                    img :  '/static/tutorial/functions/file/1. 파일/7. 다른 이름으로 저장.png',
                    subject: this.EventBus.getText("file_saveAs"),
                    explain: this.EventBus.getText("file_saveAs_ex")
                },
            ],
            file2: [   
                {
                    index: 11,
                    img :  '/static/tutorial/functions/file/1. 파일/9. 내보내기.png',
                    subject: this.EventBus.getText("file_export"),
                    explain: this.EventBus.getText("file_export_ex")
                },
                {
                    index: 12,
                    img :  '/static/tutorial/functions/file/1. 파일/9. STL로 내보내기.png',
                    subject: this.EventBus.getText("file_exportSTL"),
                    explain: this.EventBus.getText("file_exportSTL_ex")
                },
                {
                    index: 13,
                    img : '/static/tutorial/functions/file/1. 파일/9. 다른 형식으로 내보내기.png',
                    subject: this.EventBus.getText("file_exportAs"),
                    explain: this.EventBus.getText("file_exportAs_ex")
                },
                {
                    index: 14,
                    img :  '/static/tutorial/functions/file/1. 파일/10. 선택한 것만 내보내기.png',
                    subject: this.EventBus.getText("file_exportSelected"),
                    explain: this.EventBus.getText("file_exportSelected_ex")
                },
                {
                    index: 15,
                    img :  '/static/tutorial/functions/file/1. 파일/10. STL로 내보내기.png',
                    subject: this.EventBus.getText("file_exportSTLselected"),
                    explain: this.EventBus.getText("file_exportSTLselected_ex")
                },
                {
                    index: 16,
                    img :  '/static/tutorial/functions/file/1. 파일/10. 다른 형식으로 내보내기.png',
                    subject: this.EventBus.getText("file_exportAsSelected"),
                    explain: this.EventBus.getText("file_exportAsSelected_ex")
                },
            ]
            
        }
    },
}
</script>

<style scoped>
    .introduction{
        margin: 7vw auto;
        text-align: center;
    }

    h1{
        font-weight: 700;
        color: #141414;
        font-size: 30px;
        
    }

    h2{
        font-weight: 700;
        color: #5E5E5E;
        font-size: 20px;
        letter-spacing: 0.1rem;
        margin-bottom: 10px;
    }


    .introduction img{
        width: 900px;
        margin: 1vw;
        box-shadow: 0px 0px 10px 5px rgba(0,0,0,0.05);
    }

    .back img{
        margin-left: 100px;
        width: 35px;
        box-shadow: none;
        display: flex;
        position: fixed;
    }
    p{
        font-size: 16px;
        letter-spacing: 00.01rem;
        color: black;
    }

    .container_wrap{
        background-color: #F8F6F6;
    }

    .container{
        display: flex;
        flex-wrap: wrap;
        /* justify-content: space-evenly; */
        align-content: space-evenly;
        align-items: center;
        padding-top: 100px;
        padding-left: 100px;

    }
    .item {
        width: 280px;
        height: 280px;
        border-radius: 70px;
        padding: 40px 45px;
        margin-bottom: 60px;
        margin-right: 40px;
    }

    .item p{
        font-size: 15px;
        line-height: 1.2rem;
        letter-spacing: 0.05rem;
    }

    .item h2{
        font-size: 20px;
        margin: 5;
    }

    .item img{
        width: 60px;
        margin: 5px 0px 20px 0px;
    }

    .item1_wrap{
        width: 100vw;
    }
    .item1{
        background-color: #645DC7;
        /* align-self: left; */
        /* width: vw; */
    }
    .item1 h2{
        color: white;
    }
    .item1 p{
        color: white;
    }
    .item2{
        background-color: white;
    }
</style>


// WEBPACK FOOTER //
// src/pages/tutorial_functions/function_file.vue